import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 110,
    damping: 24,
    mass: 0.3,
    restDelta: 0.001,
  });

  return <motion.div style={{ scaleX }} className="scroll-progress" />;
};

export default ScrollProgress;
